import {
  CheckCircle2, Clock, Activity, AlertCircle, Send, Loader2, PauseCircle, XCircle,
} from 'lucide-react';

/**
 * Single source of truth for order/batch status meta.
 * Wszystkie ekrany (HistoryPage, AdminPage, LiveDashboard, NewOrderPage QueueProgress)
 * powinny pobierać label/icon/variant stąd zamiast definiować lokalnie.
 */
export const STATUS_META = {
  done:       { variant: 'success', label: 'Gotowe',        icon: CheckCircle2 },
  sent:       { variant: 'info',    label: 'Wysłane',       icon: Send },
  processing: { variant: 'brand',   label: 'Procesowanie',  icon: Loader2,    dot: true, spin: true },
  queued:     { variant: 'neutral', label: 'W kolejce',     icon: Clock },
  pending:    { variant: 'warning', label: 'Oczekujące',    icon: Clock },
  paused:     { variant: 'warning', label: 'Wstrzymane',    icon: PauseCircle },
  error:      { variant: 'danger',  label: 'Błąd',          icon: AlertCircle },
  failed:     { variant: 'danger',  label: 'Nieudane',      icon: XCircle },
  active:     { variant: 'brand',   label: 'Aktywne',       icon: Activity,   dot: true },
  idle:       { variant: 'success', label: 'System idle',   icon: CheckCircle2 },
};

export const ACTIVE_STATUSES   = ['processing', 'queued', 'pending'];
export const TERMINAL_STATUSES = ['done', 'sent', 'error', 'failed'];

export function getStatusMeta(status) {
  return STATUS_META[status] || STATUS_META.queued;
}

export function isActiveStatus(status) {
  return ACTIVE_STATUSES.includes(status);
}
